module.exports = __webpack_public_path__ + "media/images/ic_filter-38710bcf3331430d613d72a1d9bd8876.svg";